import { Layout as AntLayout } from 'antd';
import TopRedirectBanner from 'components/TopRedirectBanner';
import usePersistedState from 'hooks/usePersistedState';
import useRedirectUrl from 'hooks/useRedirectUrl';
import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

function Layout({
  hasSidebar = true, header, children, overflowX = 'scroll',
}) {
  const [collapsed, setCollapsed] = usePersistedState(
    false,
    'sidebar/collapsed',
  );
  const redirectUrl = useRedirectUrl();
  if (!hasSidebar) {
    return (
      <AntLayout className="site-layout">
        <AntLayout.Content style={{ overflowX: 'scroll' }}>
          {children}
        </AntLayout.Content>
      </AntLayout>
    );
  }
  return (
    <>
      <TopRedirectBanner />
      <AntLayout style={{ minHeight: '100vh' }} hasSider>
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          // style={{ top: redirectUrl ? 55 : 0 }}
          style={{ top: 55 }}
        />
        <AntLayout className="site-layout" style={{ marginLeft: collapsed ? 80 : 240 }}>
          <div>
            {header}
            <AntLayout.Content style={{ overflowX }}>
              <div className="ml-5 lg:ml-16 mr-4 lg:mr-8 mt-2 lg:mt-4 mb-10">
                {children}
              </div>
            </AntLayout.Content>
          </div>
        </AntLayout>
      </AntLayout>
    </>

  );
}

Layout.Header = Header;
export default Layout;
